export const PATH_EQUIPEMENT = "/equipement";
export const KEY_EQUIPEMENT = "equipement";
export const TITLE_EQUIPEMENT = "Équipement";

export const PATH_EQUIPEMENT_LOT_TRACKER = `${PATH_EQUIPEMENT}/lot-tracker`;
export const KEY_EQUIPEMENT_LOT_TRACKER = `${KEY_EQUIPEMENT}/lot-tracker`;
export const TITLE_EQUIPEMENT_LOT_TRACKER = "Liste des Lots de Trackers";

export const PATH_EQUIPEMENT_TRACKER = `${PATH_EQUIPEMENT}/tracker`;
export const KEY_EQUIPEMENT_TRACKER = `${KEY_EQUIPEMENT}/tracker`;
export const TITLE_EQUIPEMENT_TRACKER = "Trackers GPS";
